////////// Practice Scoped Objects /////////////////

import {PracticeData, PracticeProfileType} from "@/libwyze-shared/types";
import {Devices} from "../checkin-common/types";

export class CheckinPracticeData {

  private static type: PracticeProfileType;
  private static providerInstance: CheckinPracticeDataProvider;

  // This must be called whenever current Practice selection changes.
  static async createAndInitProvider(practiceId: string): Promise<void> {
    this.type = PracticeProfileType.PROVIDER;
    this.providerInstance = new CheckinPracticeDataProvider(
      practiceId,
      new Devices(practiceId),
    );

    await this.providerInstance.init();
  }

  static shared(): CheckinPracticeDataShared {
    switch (this.type) {
      case PracticeProfileType.PROVIDER:
      case PracticeProfileType.STAFF:
        return this.providerInstance;
      default:
        throw new Error("Illegal operation.");
    }
  }

  static provider(): CheckinPracticeDataProvider {
    return this.providerInstance;
  }

  private constructor() {
  }
}

export abstract class CheckinPracticeDataShared {

  constructor(
    readonly profileType: PracticeProfileType,
    readonly practiceId: string,
  ) {
  }

  async init(): Promise<void> {
  }
}

// These are data types that are scoped to practice + (provider, staff) profile.
export abstract class CheckinPracticeProfileDataShared {

  constructor(
    readonly profileId: string,
  ) {
  }

  async init(): Promise<void> {
  }
}

export class CheckinPracticeProfileDataProvider extends CheckinPracticeProfileDataShared {

  constructor(
    profileId: string,
  ) {
    super(profileId);
  }
}

export class CheckinPracticeDataProvider extends CheckinPracticeDataShared {

  constructor(
    practiceId: string,
    readonly devices: Devices,
  ) {
    super(PracticeProfileType.PROVIDER, practiceId);
  }

  private profileData_: CheckinPracticeProfileDataProvider;

  profileData(): CheckinPracticeProfileDataProvider {
    return this.profileData_;
  }

  async init(): Promise<void> {
    await super.init();
    const provider = PracticeData.provider();
    const practiceId = provider.practiceId;
    const profileId = provider.profileData().profileId;
    this.profileData_ = new CheckinPracticeProfileDataProvider(
      profileId,
    );
  }
}
